/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import classNames from "classnames";
import React, { useState, useEffect } from "react";
import Icon from "@/read-ui/Icon";
import { IChevronLeft, IChevronRight } from "webnovel-icons";
import styles from "./index.module.scss";

const Pagination = (props) => {
  const {
    current: _current,
    showMaxPageCount = 7, // 展示最多连续多少个页码
    pageSize = 10,
    total = 0,
    defaultCurrent = 1,
    // defaultPageSize = 10,
    position = "center",
    className,
    itemClassName,
    onChange,
    itemRender,
  } = props;
  // 内部的 current
  const [current, setCurrent] = useState(_current ?? defaultCurrent);

  const totalPageNum = Math.ceil(total / pageSize);

  const handlePageNum = () => {
    // 移动端不适合展示多页的分页列表，因此只展示当前页的页码
    return [current];
  };

  const handleItemRender = (page, type, originalElement) =>
    itemRender?.(page, type, originalElement) ?? originalElement;

  const onPageClick = (page) => {
    onChange?.(page, pageSize);
    setCurrent(page);
  };

  const positionMap = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
  };

  useEffect(() => {
    if (_current) {
      setCurrent(_current);
    }
  }, [_current]);

  return (
    <div className={classNames(styles.container, className)}>
      <ul
        className={styles.pageList}
        style={{
          justifyContent: positionMap[position],
        }}
      >
        <li
          className={classNames(styles.page, itemClassName, {
            [styles.disable]: current === 1,
          })}
          key="prev"
          onClick={() => onPageClick(current - 1)}
        >
          <Icon className={"mt-2"} Svg={IChevronLeft} size={24} />
          {handleItemRender(current - 1, "prev", "PREV")}
        </li>
        {handlePageNum().map((num) => {
          return (
            <li
              key={num}
              className={classNames(styles.page, itemClassName, {
                [styles.active]: current === num,
                [styles.omission]: !num,
              })}
              onClick={() => onPageClick(num ?? current)}
            >
              {handleItemRender(num, "page", num)}
            </li>
          );
        })}
        <li
          key="next"
          className={classNames(styles.page, itemClassName, {
            [styles.disable]: current >= totalPageNum,
          })}
          onClick={() => onPageClick(current + 1)}
        >
          {handleItemRender(current + 1, "next", "NEXT")}
          <Icon className={"mt-2"} Svg={IChevronRight} size={24} />
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
